import React from 'react';

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <img 
              src="/images/logo-yodywhite.png" 
              alt="Yody Logo" 
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            Thông báo
          </h1>
        </div>

        <div className="space-y-6">
          <div className="text-center">
            <p className="text-lg font-semibold text-gray-800 mb-4">
              Chương trình tri ân "Mua 10 tặng 1" đã kết thúc
            </p>
            <p className="text-gray-600 mb-4">
              Cảm ơn mọi người đã quan tâm và tham gia
            </p>
            <p className="text-gray-600 text-sm">
              Nếu có thắc mắc hoặc cần hỗ trợ về chương trình, vui lòng liên hệ về Đại lý hoặc Hotline trên bao bì
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;

